import type { IntlShape } from 'react-intl'

export function getTimeBasedGreeting(intl: IntlShape): string {
  const hour = new Date().getHours()
  if (hour < 12) return intl.formatMessage({ id: 'YwkOVoNWV74QDsCmUOba', defaultMessage: 'Good morning', description: 'Time-based greeting for morning hours on LuxPlus landing page' })
  if (hour < 18) return intl.formatMessage({ id: 'PfElS5gjgzLV69z7X2Sn', defaultMessage: 'Good afternoon', description: 'Time-based greeting for afternoon hours on LuxPlus landing page' })
  return intl.formatMessage({ id: 'caVIZe3ANPnU7Ooio-oA', defaultMessage: 'Good evening', description: 'Time-based greeting for evening hours on LuxPlus landing page' })
}
